module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row wrapper"
  }, [_c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "integration-section"
  }, [_c('img', {
    attrs: {
      "src": _vm.computedLogoSrc
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "integration-section"
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.$t(("ui.integrations." + _vm.label))) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "integration-section"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-1 switch"
  }, [_c('form-switch', {
    ref: "switch",
    attrs: {
      "label": "empty",
      "value": _vm.value
    },
    on: {
      "input": _vm.updateActive
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-885ffe7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/integrations/Integration.vue
// module id = 1962
// module chunks = 0